import React from "react";
import CustomTabsGrid from "components/CustomTabs/CustomTabsGrid.js";
import Thongtinthue from "components/Thongtinthue/Thongtinthue.js";
export default function BCXedulichhopdong() {
  return (
    <div>
      <CustomTabsGrid
        headerColor="primary"
        tabs={[
          {
            tabName: "Báo cáo thông tin nợ đọng thuế",
            tabContent: <Thongtinthue />,
          },
        ]}
      />
    </div>
  );
}
